import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from '../firebase';
import { isLicenseDateExpired } from '../utils/planLimits';

export const isOwnerLicenseValid = (license) => {
  // undefined = まだ読み込み中 → 非表示
  if (license === undefined) return false;
  // null = licenseノード自体がない（superadmin所有イベント等）→ 制限なし
  if (license === null) return true;
  if (license.status !== 'active') return false;
  if (license.expires_at && isLicenseDateExpired(license.expires_at)) return false;
  return true;
};

export const useOwnerLicenses = (ownerIds) => {
  const [licenses, setLicenses] = useState({});
  const idKey = [...ownerIds].sort().join(',');

  useEffect(() => {
    if (!ownerIds || ownerIds.length === 0) {
      setLicenses({});
      return;
    }

    const licenseData = {};
    const unsubscribers = ownerIds.map((uid) => {
      const licRef = ref(db, `users/${uid}/license`);
      return onValue(licRef, (snap) => {
        licenseData[uid] = snap.val();
        setLicenses({ ...licenseData });
      });
    });

    return () => unsubscribers.forEach((unsub) => unsub());
  }, [idKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return licenses;
};
